import React from 'react';
import { noocoLogo } from './logo';
import './pdfHeader.scss';
import { useTranslation } from 'react-i18next';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import { TEMPLATE_TYPE_NAME } from '../../../models';

import { airportLogo } from './logo';
import { infrastructureExterieurLogo } from './logo';
import { dataCenterLogo } from './logo';
import { prototypeLogo } from './logo';
import { exploitationLogo } from './logo';
import { renovationLogo } from './logo';
import { bbcaLogo } from './logo';
import { epcmLogo } from './logo';
import { re2020Logo } from './logo';
import { globalMonitoringLogo } from './logo';
import { ecoconceptionLogo } from './logo';

export type PdfHeaderProps = {
  companyLogo: string | null;
  projectName: string;
  generationDate: string;
  companyPostCode: string;
  projectPostCode: string;
  projectLocation: string;
  carbonImpact: number;
  carbonUnit: string;
  projectArea: number;
  projectUnit: string;
  projectType: string;
  i18nInstance?: any;
};

export function PdfHeader({
  companyLogo,
  projectName,
  generationDate,
  projectPostCode,
  projectLocation,
  projectArea,
  projectUnit,
  carbonImpact,
  carbonUnit,
  projectType,
  i18nInstance = null,
}: PdfHeaderProps) {
  const { t: defaultT } = useTranslation();
  const t = i18nInstance ? i18nInstance.getFixedT() : defaultT;

  const returnDefaultStyleForProjectTypeLogo = (
    width: string | null = '51px',
    filter:
      | string
      | null = 'invert(65%) sepia(28%) saturate(842%) hue-rotate(124deg) brightness(87%) contrast(99%)'
  ) => {
    return {
      width,
      height: 'auto',
      marginLeft: '1em',
      filter,
    };
  };

  const selectLogo = (projectType) => {
    switch (projectType) {
      case TEMPLATE_TYPE_NAME.AIRPORT:
        return {
          logo: airportLogo,
          style: returnDefaultStyleForProjectTypeLogo(),
        };
      case TEMPLATE_TYPE_NAME.OUTDOOR:
        return {
          logo: infrastructureExterieurLogo,
          style: returnDefaultStyleForProjectTypeLogo(),
        };

      case TEMPLATE_TYPE_NAME.DATACENTER:
        return {
          logo: dataCenterLogo,
          style: returnDefaultStyleForProjectTypeLogo(),
        };
      case TEMPLATE_TYPE_NAME.PROTOTYPE:
        return {
          logo: prototypeLogo,
          style: returnDefaultStyleForProjectTypeLogo(),
        };
      case TEMPLATE_TYPE_NAME.EXPLOITATION:
        return {
          logo: exploitationLogo,
          style: returnDefaultStyleForProjectTypeLogo(),
        };
      case TEMPLATE_TYPE_NAME.NOOCO:
        return {
          logo: ecoconceptionLogo,
          style: returnDefaultStyleForProjectTypeLogo(),
        };
      case TEMPLATE_TYPE_NAME.RENOVATION:
        return {
          logo: renovationLogo,
          style: returnDefaultStyleForProjectTypeLogo(),
        };
      case TEMPLATE_TYPE_NAME.EPCM:
        return {
          logo: epcmLogo,
          style: returnDefaultStyleForProjectTypeLogo(null, 'none'),
        };
      case TEMPLATE_TYPE_NAME.BBCA:
        return {
          logo: bbcaLogo,
          style: returnDefaultStyleForProjectTypeLogo(null, 'none'),
        };
      case TEMPLATE_TYPE_NAME.RE2020:
        return {
          logo: re2020Logo,
          style: returnDefaultStyleForProjectTypeLogo('103px', 'none'),
        };
      case TEMPLATE_TYPE_NAME.GLOBAL_MONITORING:
        return {
          logo: globalMonitoringLogo,
          style: returnDefaultStyleForProjectTypeLogo(),
        };
      default:
        return '';
    }
  };

  const projectTypeWithoutArea = [
    TEMPLATE_TYPE_NAME.OUTDOOR,
    TEMPLATE_TYPE_NAME.DATACENTER,
  ];

  let conditionToDisplaySurface =
    !projectTypeWithoutArea.includes(projectType) && projectUnit === 'm²';

  const logoObject = selectLogo(projectType);
  return (
    <div className="pdfHeader-wrapper">
      <div className="logo-part">
        {companyLogo ? (
          <img
            className="img-format"
            src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png"
            alt="logo"
          />
        ) : (
          <div className="img-format"></div>
        )}
        <img className="img-format" src={noocoLogo} alt="logo" />
      </div>
      <div className="title-part">
        <h1 className="pdfHeader-title">{projectName}</h1>
        <p style={{ color: '#3adcc9' }}>
          {t('APP.NOOCO_UI.PDF_HEADER.GENERATE', {
            generationDate,
            defaultValue: `Généré le ${generationDate}`,
          })}
        </p>
      </div>
      <div className="information-data-project">
        <div className="data-part">
          <LocationOnIcon className="icon-logo" />
          <div className="detail-data">
            <p className="main-data">{projectPostCode}</p>
            <p className="sub-data">{projectLocation}</p>
          </div>
        </div>
        {conditionToDisplaySurface && (
          <div className="data-part">
            <AspectRatioIcon className="icon-logo" />
            <div className="detail-data">
              <p className="main-data">{projectArea}</p>
              <p className="sub-data">{projectUnit}</p>
            </div>
          </div>
        )}

        <div className="data-part">
          <img
            style={logoObject.style}
            src={logoObject.logo}
            className="icon-logo"
          />
          <div className="detail-data">
            <p className="main-data">{carbonImpact.toFixed(2)}</p>
            <p className="sub-data">{carbonUnit}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
